module.exports = __webpack_public_path__ + "static/media/12.4a1b4214.JPG";